var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessagePlus = function SvgMessagePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C3.44772 4 3 4.44772 3 5V16V19.7919C3 19.8758 3.09699 19.9224 3.16247 19.87L6.75 17H20C20.5523 17 21 16.5523 21 16V5C21 4.44772 20.5523 4 20 4Z",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.25736L12 14.7426M7.75732 10.5L16.2426 10.5",
    strokeWidth: 1.2
  })));
};
export default SvgMessagePlus;